// Constants
import Errors from './errors';
import { DELIVERY_VANS } from "./deliveryVans";
export var BANNER_PRIMARY_BUTTON = 'cb-button-primary';
export var BANNER_SECONDARY_BUTTON = 'cb-button-secondary';
export var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export var CATALOGUETYPES = {
  retail: "CB_Retail_Store",
  cater: "CB_Food_Catering",
  food: "CB_Food_Store"
};
export var CATALOGUENAMES = {
  "CB_Retail_Store": "shop",
  "CB_Food_Catering": "catering",
  "CB_Food_Store": "eat"
};
export { Errors, DELIVERY_VANS };